const release2025 = [
  {
    date: '2025-12-29',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 상태 변경 가능 조건 확장
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail: 
            <>
              - <strong>반품완료</strong> : 현재 주문상태가 [주문재확인, <strong>반품요청</strong>]인 경우 변경 가능<br/>
              - <strong>교환완료</strong> : 현재 주문상태가 [주문재확인, <strong>교환요청</strong>]인 경우 변경 가능<br/>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2025-12-24',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API Request 파라미터 <code>search_key</code>의 주문자, 수령자 연락처 키값 통합
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
            detail:
            <>
              - 기존: 주문자 전화번호 <code>order_tel</code>, 주문자 휴대전화번호<code>order_htel</code>, 수령자 전화번호<code>to_tel</code>, 수령자 휴대전화번호<code>to_htel</code><br />
              - 수정: 주문자, 수령자 연락처 <code>tel</code>
            </>
          }
        ]
      }
    ],
  },
  {
    date: '2025-12-10',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 조회 API 상태(status) 관련 필드명/필드값 변경
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
            detail: 
            <>
              - 필드명: 요청 - <code>status</code> | 응답 - <code>ord_status</code>
              - 요청, 응답 필드값: <code>반품진행</code> → <code>반품접수</code> | <code>교환진행</code> → <code>교환접수</code>
            </>
          },
          {
            method: 'GET',
            action: '/order/:uniq',
            detail:
            <>
              - 필드명: 응답 - <code>ord_status</code>
              - 응답 필드값: <code>반품진행</code> → <code>반품접수</code> | <code>교환진행</code> → <code>교환접수</code>
            </>
          },
          {
            method: 'GET',
            action: '/orders/count',
            detail: 
            <>
              - 필드명: 요청 - <code>ord_status</code>
              - 요청 필드값: <code>반품진행</code> → <code>반품접수</code> | <code>교환진행</code> → <code>교환접수</code>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2025-11-21',
    items: [
      {
        type: 'Added',
        summary:
        <>
          세트상품 등록/수정 API 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/set-add',
          },
          {
            method: 'PUT',
            action: '/stock/set-edit',
          }
        ]
      }
    ]
  },
  {
    date: '2025-10-13',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API Request 파라미터 <code>bundle_yn</code>의 세부 기능 추가 및 설명 수정
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',  
            detail:
            <>
              - 기존: 묶음번호가 생성여부 상관없이 모든 주문건 조회<br/>
              - 변경: 묶음번호의 생성 여부 상관없이 모든 주문 건 조회 (신규주문 제외)
            </>
          }
        ]
      }     
    ]
  },
  {
    date: '2025-09-24',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API Response <code>결제완료</code> 상태의 주문은 출고가능 여부 <code>ship_avail_yn</code> 항상 <code>1</code> 로 반환
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2025-09-04',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          수집 상품 리스트 조회 API Response <code>template_info</code> 삭제
        </>,
        apis: [
          {
            method: 'GET',
            action: '/product/online/listOfScrap',
          }
        ]
      }
    ]
  },
  {
    date: '2025-08-27',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 파라미터 무형상품 주문 건 조회 여부 <code>non_shipping_yn</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2025-07-24',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API Response 쇼핑몰 상품 URL <code>shop_prod_url</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2025-06-24',
    items: [
      {
        type: 'Added',
        summary:
        <>
          온라인상품 등록/수정/상세 조회 API v1.2 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/add/v1.2',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.2',
          },
          {
            method: 'GET',
            action: '/products/:ol_shop_no/v1.2',
          }
        ]
      },
    ]
  },
  {
    date: '2025-05-29',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          세트상품 조회 API Response 세트에 할당된 SKU상품 출고 수량 <code>set_pack_units</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/sets',
          }
        ]
      }
    ]
  },
  {
    date: '2025-04-18',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회/상세조회 API Response 옵션관리코드 <code>opt_custom_cd</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          },
          {
            method: 'GET',
            action: '/orders/:uniq'
          }
        ]
      }
    ]
  },
  {
    date: '2025-04-16',
    items: [
      {
        type: 'Added',
        summary:
        <>
          작업리스트 조회 API 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/list',
          }
        ]
      }
    ]
  },
  {
    date: '2025-02-28',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          선택작업 등록 API 상품 부분 수정 작업 등록 시 e6039(올바르지 않은 부분수정항목이 있습니다.) 에러 코드 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
          }
        ]
      }
    ]
  },
  {
    
    date: '2025-02-26',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          SKU별 추정 매출현황 조회 API 파라미터 search_key 지원 필드 <code>shop_ord_no</code> 추가
        </>,
        apis: [
          {
            authorized_sol_ser: 'cal_state_per_prod',
            method: 'POST',
            action: '/calculate/state-per-prod-list',
          }
        ]
      }
    ]
  },
  {
    date: '2025-02-06',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 파라미터 orderby 지원 필드 <code>mdate, shop_ord_no</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2025-02-05',
    items: [
      {
        type: 'Added',
        summary:
        <>
          SKU별 추정 매출현황 조회 API 추가
        </>,
        apis: [
          {
            authorized_sol_ser: 'cal_state_per_prod',
            method: 'POST',
            action: '/calculate/state-per-prod-list',
          }
        ]
      }
    ]
  }
]

export default release2025;